<template>
    <div>
        <avue-crud
                :option="option"
                :data="data"
                :page="page"
                @refresh-change="refreshChange"
                @search-change="searchChange"
                @row-save="store"
                @row-update="update"
                @row-del="del"
                @size-change="sizeChange"
                @current-change="currentChange"
                :upload-before="uploadBefore"
                ref="crud"
        >
            <template slot="menuLeft">
                <el-button size="small" icon="el-icon-download" type="success"
                           @click="excelExport('在线信箱', '用户、工号、电话、反馈对象、反馈类型、反馈内容、反馈时间、是否需要回复、回复内容、回复时间')">导出Excel
                </el-button>
            </template>
            <template slot-scope="scope" slot="menu">
                <el-button icon="el-icon-view" size="small" type="text"
                           @click.stop="handleShow(scope.row,scope.index)">查看
                </el-button>
                <el-button icon="el-icon-edit" size="small" type="text" v-if="scope.row.is_reply===1"
                           @click.stop="handleReply(scope.row,scope.index)">回复管理({{ scope.row.reply_count }})
                </el-button>
            </template>

            <template slot-scope="scope" slot="is_reply">
                <span v-if="scope.row.is_reply===1" style="color: crimson">需要回复</span>
                <span v-if="scope.row.is_reply===2" style="color: #9a9a9f">不需要回复</span>
            </template>
        </avue-crud>

        <el-dialog title="回复管理" :visible.sync="dialogMailboxReplyVisible" :modal="false" width="80%" center>
            <MailboxReply :defaultParams="{mailboxId : this.mailboxId }"></MailboxReply>
        </el-dialog>

        <el-dialog title="查看详情" :visible.sync="dialogShowVisible">
            <el-form :model="form">
                <el-form-item label="反馈对象:" :label-width="formLabelWidth">
                    <!--<el-input v-model="form.$object" autocomplete="off" disabled="disabled" style="color: #1a1a1a"></el-input>-->
                    <input v-model="form.$object" disabled="disabled"
                           style="padding:10px;background-color:#f6f6f6;border:solid 1px #eee;color: #000000;border-radius:4px;width:90%;" />
                </el-form-item>
                <el-form-item label="反馈方式:" :label-width="formLabelWidth">
                    <!--<el-input v-model="form.$way" autocomplete="off" disabled="disabled"></el-input>-->
                    <input v-model="form.$way" disabled="disabled"
                           style="padding:10px;background-color:#f6f6f6;border:solid 1px #eee;color: #000000;border-radius:4px;width:90%;" />
                </el-form-item>
                <el-form-item label="反馈类型:" :label-width="formLabelWidth">
                    <!--<el-input v-model="form.$type" autocomplete="off" disabled="disabled"></el-input>-->
                    <input v-model="form.$type" disabled="disabled"
                           style="padding:10px;background-color:#f6f6f6;border:solid 1px #eee;color: #000000;border-radius:4px;width:90%;" />
                </el-form-item>
                <el-form-item label="用户:" :label-width="formLabelWidth">
                    <!--<el-input v-model="form['user-username']" autocomplete="off" disabled="disabled"></el-input>-->
                    <input v-model="form['user-username']" disabled="disabled"
                           style="padding:10px;background-color:#f6f6f6;border:solid 1px #eee;color: #000000;border-radius:4px;width:90%;" />
                </el-form-item>
                <el-form-item label="所属部门:" :label-width="formLabelWidth">
                    <!--<el-input v-model="form['user-class']" autocomplete="off" disabled="disabled"></el-input>-->
                    <input v-model="form['user-class']" disabled="disabled"
                           style="padding:10px;background-color:#f6f6f6;border:solid 1px #eee;color: #000000;border-radius:4px;width:90%;" />
                </el-form-item>
                <el-form-item label="是否回复:" :label-width="formLabelWidth">
                    <!--<el-input v-model="form.$is_reply" autocomplete="off" disabled="disabled"></el-input>-->
                    <input v-model="form.$is_reply" disabled="disabled"
                           style="padding:10px;background-color:#f6f6f6;border:solid 1px #eee;color: #000000;border-radius:4px;width:90%;" />
                </el-form-item>
                <el-form-item label="反馈内容:" :label-width="formLabelWidth">
                    <!--<el-input v-model="form.content" autocomplete="off" type="textarea" disabled="disabled"></el-input>-->
                    <textarea v-model="form.content" disabled="disabled"
                              style="padding:10px;background-color:#f6f6f6;border:solid 1px #eee;color: #000000;border-radius:4px;width:90%;height:200px;"></textarea>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
  import curd from './Base/Crud'
  import MailboxReply from './MailboxReply'

  export default {
    mixins: [curd],
    components: {MailboxReply},
    data() {
      return {
        form: {},
        // curd组件
        option: {
          viewBtn: false, // 查看按钮显隐
          addBtn: false, // 增加按钮显隐
          addBtnText: '新增通知', // 新增按钮文案
          editBtn: false, // 修改按钮显隐
          editBtnText: '回复',
          delBtn: false, // 删除按钮显隐
          columnBtn: false, // 列显隐按钮
          headerAlign: 'center', // 表头居中
          align: 'center', // 表内容 居中
          searchMenuSpan: 5, // 搜索同行 搜索所占宽度
          index: true, // 行首 索引
          dialogClickModal: false, // 是否可以通过点击modal关闭Dialog
          column: [
            {
              label: '反馈内容',
              overHidden: true,
              prop: 'content',
              editDisplay: false,
              span: 24,
              type: 'textarea',
              align: 'left',
            }, {
              label: '反馈时间',
              prop: 'created_at',
              search: true,
              type: 'datetimerange',
              valueFormat: 'yyyy-MM-dd HH:mm:ss',
              editDisplay: false,
              span: 24
            }, {
              label: '反馈对象',
              // overHidden: true,
              prop: 'object',
              type: 'select',
              editDisplay: false,
              dicData: [{'label': '工会', 'value': 1}, {'label': '公司', 'value': 2}],
              span: 8
            }, {
              label: '反馈方式',
              prop: 'way',
              type: 'select',
              editDisplay: false,
              dicData: [{'label': '咨询', 'value': 1}, {'label': '投诉', 'value': 2}],
              span: 8
            }, {
              label: '反馈类型',
              // overHidden: true,
              prop: 'type',
              type: 'select',
              editDisplay: false,
              dicData: [{'label': '制度', 'value': 1}, {'label': '福利', 'value': 2}, {
                'label': '工作',
                'value': 3
              }, {'label': '其他', 'value': 4}],
              span: 8
            }, {
              label: '用户',
              prop: 'user-username',
              editDisplay: false,
              span: 8
            }, {
              label: '所属部门',
              prop: 'user-class',
              editDisplay: false,
              span: 8
            }, {
              label: '是否回复',
              prop: 'is_reply',
              type: 'select',
              search: true,
              slot: true,
              editDisplay: false,
              dicData: [{'label': '需要', 'value': 1}, {'label': '不需要', 'value': 2}],
              span: 8
            }
          ]
        },
        mailboxId: null,
        dialogMailboxReplyVisible: false,
        dialogShowVisible: false,
        formLabelWidth: '100px'
      }
    },
    methods: {
      // 回复
      handleReply(row) {
        this.dialogMailboxReplyVisible = true;
        this.mailboxId = row.id;
      },
      // 查看
      handleShow(row) {
        console.log(row['user-class']);
        this.form = row;
        this.dialogShowVisible = true;
      },
      // 导出Excel文件统一处理
      excelExport(filename = new Date().getTime(), field) {
        this.$confirm('导出将由服务器后端执行，需要时间等待，完成后会在右上角提示下载，该导出包含以下内容: ' + field, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          const message = this.$notify({
            title: '通知',
            message: '服务器处理中...',
            showClose: false,
            duration: 0
          });
          this.api.get(this.url + '/export?filename=' + filename, this.searchParams).then((re) => {
            message.close();
            if (re.code === 0) {
              let url = this.config.baseURL + '/excel/download/' + re.data;
              this.$notify({
                title: '导出成功!',
                dangerouslyUseHTMLString: true,
                type: 'success',
                duration: 0, // 不会自动关闭的消息
                message: filename + '数据导出完成 下载导出文件:<a target="_blank" href="' + url + '">下载' + filename + 'Excel</a>'
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          });
        });
      },
      // 导入Excel 成功回调
      excelImportSuccess() {
        this.initialization();
      }
    }
  }
</script>
